import { render, staticRenderFns } from "./calendar_preview_widget.vue?vue&type=template&id=2822682b&scoped=true"
import script from "./calendar_preview_widget.vue?vue&type=script&lang=js"
export * from "./calendar_preview_widget.vue?vue&type=script&lang=js"
import style0 from "./calendar_preview_widget.vue?vue&type=style&index=0&id=2822682b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822682b",
  null
  
)

export default component.exports